import React from 'react'

export default function InputClose() {
  return (
    <svg width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="8" height="8" rx="4" fill="#C5C5C5" />
      <path d="M3 3L5 5" stroke="white" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 3L3 5" stroke="white" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
